import { Component, OnInit, OnDestroy } from '@angular/core';
import { IoService } from '../../../services/io.service';
import { Subscription } from 'rxjs';
import { EChartOption, EChartsSeriesType } from 'echarts';
const CHART_MS = 15 * 60 * 1000;
const MAX_TEMPERATURE = 80;
const MAX_WEIGHT = 200;

@Component({
  selector: 'app-dashboard-quality',
  templateUrl: './dashboard-quality.component.html',
  styleUrls: ['./dashboard-quality.component.css']
})
export class DashboardQualityComponent implements OnInit, OnDestroy {
  private subDeviceQualityTemperature: Subscription;
  private subDeviceQualityWeight: Subscription;
  private subDeviceQualityProd: Subscription;
  temperature: number;
  weight: number;
  weightStable: boolean;
  private triggerAlive: object;
  private prod: boolean;
  private prodTemperature: string;
  private prodWeight: string;
  private prodTimeout;


  private chartOptionGlobal: EChartOption = {
    grid: {top: 6, bottom: 40, left: 30, right: 18 },
    color: ['#666', '#df7e00'],
    animation: false,
    xAxis: {
        scale: true,
        type: 'time',
        axisLabel: {
          // interval: 5 * 60 * 1000 * 100 //5 Min?
          padding: [0, 3]
        }
    }
  };

  private chartOptionWeight: EChartOption = Object.assign({
    // title: { text: 'Gewicht' },
    yAxis: {
      min: 0,
      max: MAX_WEIGHT + 1, // sonst sieht man Werte mit MAX nicht
      splitLine: { show: false }
    },
    series: [{
      type: 'scatter',
      symbolSize: 6,
      data: []
    }, {
      type: 'effectScatter',
      symbolSize: 10,
      zlevel: 1,
      data: []
    }]
  }, this.chartOptionGlobal);


  private chartOptionTemperature: EChartOption = Object.assign({
    yAxis: {
      min: 0,
      max: MAX_TEMPERATURE + 1, // sonst sieht man Werte mit MAX nicht
      splitLine: { show: false }
    },
    series: [{
      type: 'scatter',
      symbolSize: 6,
      data: []
    }, {
      type: 'effectScatter',
      symbolSize: 10,
      zlevel: 1,
      data: []
    }]
  }, this.chartOptionGlobal);

  constructor(private ioService: IoService) { }

  ngOnInit() {

    this.subDeviceQualityTemperature = this.ioService.getDeviceEvents('quality.temperature').subscribe(ev => {
      console.log(ev);
      this.temperature = ev.temperature;
      this.chartOptionTemperature = this.chartPush(this.chartOptionTemperature, [ev.t, Math.min(ev.temperature, MAX_TEMPERATURE)], 0);
    });

    this.subDeviceQualityWeight = this.ioService.getDeviceEvents('quality.weight').subscribe(ev => {
      console.log(ev);
      this.weight = ev.weight;
      this.weightStable = ev.stable;
      this.chartOptionWeight = this.chartPush(this.chartOptionWeight, [ev.t, Math.min(ev.weight, MAX_WEIGHT)], 0);
    });

    this.subDeviceQualityProd = this.ioService.getDeviceEvents('quality.prod').subscribe(ev => {
      console.log(ev);
      if (ev.weight) {
        this.prodWeight = ev.weight;
        this.chartOptionWeight = this.chartPush(this.chartOptionWeight, [ev.t, ev.weight], 1);
      }
      if (ev.temperature) {
        this.prodTemperature = ev.temperature;
        this.chartOptionTemperature = this.chartPush(this.chartOptionTemperature, [ev.t, ev.temperature], 1);

      }
      this.prod = true;
      clearTimeout(this.prodTimeout);
      this.prodTimeout = setTimeout(() => this.prod = false, 1500);
    });

  }

  ngOnDestroy() {
    if (this.subDeviceQualityTemperature) { this.subDeviceQualityTemperature.unsubscribe(); }
    if (this.subDeviceQualityWeight) { this.subDeviceQualityWeight.unsubscribe(); }
    if (this.subDeviceQualityProd) { this.subDeviceQualityProd.unsubscribe(); }
  }

  private chartPush(option /*: EChartOption*/, d: any, idx: number) {
    const now = Date.now();
    option.series[idx].data.push(d);
    option.series[idx].data = option.series[idx].data.filter(e => e && e[0] && e[0] + CHART_MS > now); // filter by time
    this.triggerAlive = {};
    return Object.assign({}, option); // trigger echarts change detection is triggered
    // Other option https://xieziyu.github.io/ngx-echarts/#/home
    // With drawback that I need to hold optiommerge and data for every chart seperately...
  }
}
